import React, { useContext } from "react";
import "./Footer.css";
import "./ResponsiveFooter.css";
import { Dropdown, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { dataContext } from "../../context/DataContextProviderr";
import { filterKey } from "../../helper/function";

const Footer = () => {
  const navigate = useNavigate();
  const navigateHandler = (path) => {
    navigate(path);
  };
  const { allWebParts } = useContext(dataContext);
  const filterAllWebParts = allWebParts?.filter(
    (x) => x.uniqueName === "footer-homePage"
  );
  return (
    <div className="footer-home">
      <div className="content-container">
        <div className="left">
          <div className="top">
            <img src="/pic/logo.png" alt="logo" />
            <p>ارتباط با ما</p>
          </div>
          <div className="bottom">
            <div className="form-container">
              <Form>
                <Form.Group className="mb-3">
                  <Form.Control type="text" placeholder="نام و نام خانوادگی " />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control type="number" placeholder="شماره موبایل" />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Dropdown className="items">
                    <Dropdown.Toggle>نوع محصول</Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item>خبازی</Dropdown.Item>
                      <Dropdown.Item>صنعتی</Dropdown.Item>
                      <Dropdown.Item>قنادی</Dropdown.Item>
                      <Dropdown.Item>دامپروری</Dropdown.Item>
                      <Dropdown.Item>خوراک دام</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Dropdown className="items">
                    <Dropdown.Toggle>نوع پیام ارسالی</Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item>شکایت</Dropdown.Item>
                      <Dropdown.Item>پیشنهاد</Dropdown.Item>
                      <Dropdown.Item>انتقاد</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="لطفا پیام خود را تایپ کنید"
                  />
                </Form.Group>

                <button
                //   type="submit"
                >
                  ارسال پیام
                </button>
              </Form>
            </div>
            <div className="address">
              <div className="call num">
                <div className="img">
                  <img src="/pic/call.png" alt="phone-icon" />
                </div>
                <div className="group-1">
                  <p>
                    {filterKey(filterAllWebParts, "tell-1")?.map(
                      (item) => item.Value
                    )}
                  </p>
                  <p>
                    {filterKey(filterAllWebParts, "tell-3")?.map(
                      (item) => item.Value
                    )}
                  </p>
                </div>
                <div className="group-2">
                  <p>
                    {filterKey(filterAllWebParts, "tell-2")?.map(
                      (item) => item.Value
                    )}
                  </p>
                  <p>
                    {filterKey(filterAllWebParts, "tell-4")?.map(
                      (item) => item.Value
                    )}
                  </p>
                </div>
              </div>
              <div className="location">
                <div className="img">
                  <img src="/pic/location.png" alt="location-icon" />
                </div>
                <div className="group-1">
                  <p>
                    {filterKey(filterAllWebParts, "address")?.map(
                      (item) => item.Value
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="top">
            <img src="/pic/logo.png" alt="logo" />
            <p>ارتباط با ما</p>
          </div>
          <div className="factory-img">
            <img
              src="/pic/factory.png"
              alt="factory-icon"
              className="factory"
            />
            <img src="/pic/footerBg1.png" alt="walpaper" className="walpaper" />
          </div>
          <div className="content">
            <p className="p1">
              نظرات و پیشنهادات خود را{" "}
              <Link to="/contactUs">
                <span className="p2">با ما</span>
              </Link>{" "}
              به اشتراک بگذارید
            </p>
            <button onClick={() => navigateHandler("/contactUs")}>
              مشاهده بیشتر
            </button>
          </div>
          <div className="shop">
            <p>سامانه خرید آرد</p>
            <a
              href={filterKey(filterAllWebParts, "purchase-flour-link")?.map(
                (item) => item.Value
              )}
              target="_blank"
              rel="noreferrer"
            >
              Gfloursale.Banksepah.Ir
            </a>
          </div>
        </div>
      </div>
      <div className="copy-right border-top">
        <p>
          {filterKey(filterAllWebParts, "footer-copyright")?.map(
            (item) => item.Value
          )}
        </p>
      </div>
    </div>
  );
};

export default Footer;
